<template>
  <div class="question-detail-wrap">
		<div class="detail main clearfix" v-if="data">
			<div class="detail_text left">
				<div class="question clearfix">
					<div class="icon_wrap left">
						<span>问</span>
					</div>
					<div class="text_wrap left">
						<p class="text">{{ data.body }}<span class="icon_wrap"><i class="iconfont icon-jinbi"></i> {{ data.gcoins }}G币</span></p>
						<p class="name_wrap clearfix">
							<span class="left">提问者：{{ data.userName }}</span>
							<span class="right">{{ data.createdAt }}</span>
						</p>
					</div>
				</div>
				<div class="answer">
          <template v-if="data.answer">
            <div class="line-0 clearfix">
              <div class="img_wrap left">
                <img :src="data.answerUserAvatar" :alt="data.answerUserName" />
              </div>
              <div class="name_wrap left">
                <p>
                  <span>{{ data.answerUserName }}</span>：{{ data.answerTime }}
                </p>
                <p>{{ data.answer }}</p>
              </div>
            </div>
          </template>
          <template v-else-if="data.status === 0">
            <!-- 未回答 2种情况，用户身份和老师身份 -->
            <!-- 老师身份 -->
            <div class="line-1 teacher_lijianswer" v-if="isTheTeacher">
              <a @click="answerShow = !answerShow" href="javascript:;">{{ answerShow ? '关闭输入框' : '立即回答该问题' }}</a>
              <div class="content-wrap" v-show="answerShow">
                <textarea maxlength="150" v-model="answerContent" placeholder="请输入回答内容"></textarea>
                <p class="action_wrap">
                  <span>限制150字</span>
                  <button type="button" @click="handleAnswer">发送</button>
                </p>
              </div>
            </div>
            <!-- 用户身份 -->
            <div class="line-2 name_wrap left" v-else>
              <span class="answer_status">等待回答</span>
            </div>
          </template>
          <template v-else-if="data.status === 1">
            <div class="line-3 inner_nolimit" @click="handleUnlock(data)">
              <div class="icon_wrap">
                <span><i class="iconfont icon-suo"></i></span>
              </div>
              <p class="info_tetx">老师已回答，您只需要支付<i>{{ Math.ceil(data.gcoins / 2) }}</i>G币即可解锁查看答案>></p>
            </div>
          </template>
          <template v-else-if="data.status === 2">
            <!-- 已过期，退款 -->
            <div class="line-4">
              <span :class="data.gcoins ? 'answer_status_tuihui' : 'answer_status_guoqi' ">{{ data.gcoins > 0 ? '超时未回答，G币已退回' : '超时未回答，提问已过期' }}</span>
            </div>
          </template>
				</div>
			</div>
      <!-- 右侧 -->
			<div class="teacher_info right">
				<div class="top" v-if="teacherInfo">
					<p class="img_wrap"><img :src="teacherInfo.avatar" :alt="teacherInfo.userName" /></p>
          <p class="action_wrap">
            {{ teacherInfo.userName }}
            <template v-if="!isTeacher">
              <span class="btn-ask" :class="{ quxiao: isLike }" @click="handleLike">{{ !isLike ? '关注' : '已关注' }}</span>
              <nuxt-link class="btn-ask" target="_blank" rel="noopener" :to="`/room/${teacherInfo.roomId}`">互动</nuxt-link>
            </template>
          </p>
          <p class="info_wrap">{{ teacherInfo.sign }}</p>
				</div>
				<!--详情页面推荐位-->
				<div class="recommend">
					<div class="recommend-item" v-for="item in $store.state.adList['payPaperTeacher']" :key="item.id">
						<div class="recommend-item-top clearfix">
							<div class="img_wrap left">
								<nuxt-link tag="img" :src="item.relationData.avatar" :to="`/question/list/${item.relationData.id}`"></nuxt-link>
              </div>
							<div class="text_wrap left">
								<p class="name_wrap clearfix">
                  <nuxt-link tag="span" :to="`/question/list/${item.relationData.id}`" class="name left">{{ item.relationData.userName }}</nuxt-link>
                  <span class="num right">已回答<i> {{ item.relationData.questionAnswerTotal }}</i></span>
                </p>
								<p class="info ellipsis yf-text_12">{{ item.relationData.sign }}</p>
							</div>
						</div>
						<div class="bottom clearfix">
							<span class="num left">{{ item.relationData.questionPrice }} <i>G币/次</i></span>
							<span class="tiwen right btn-ask" @click="handleAsk(item.relationData)">立即提问</span>
						</div>
					</div>
				</div>
				<nuxt-link class="to_allteacher" to="/question/teacher-list">查看更多老师 >></nuxt-link>
			</div>
      <!-- 右侧 over -->
		</div>
	</div>
</template>

<script>
import Dialog from '@/utils/Dialog'

export default {
	name: 'question-detail',
  scrollToTop: true,
  
  validate ({ params }) {
    return params.id > 0
  },
  async asyncData ({ params, store, error, $axios }) {
    // 获取详细数据
    let data = await $axios._get('Ask/Detail', { id: params.id })
    if (!data) {
      error({statusCode: 500, message: '问答数据加载错误，请重试'})
      return
    }
    // 获取老师信息
    let teacherInfo = await store.dispatch('teacher/getInfo', data.teacherId)

    return {
      data,
      teacherInfo,
      isLike: store.getters['user/likeTeacherIds'].indexOf(data.teacherId) !== -1
    }
  },
  head () {
    return {
      title: (this.data ? this.data.body + '-' : '') + '问答-一富财经—打造中国最靠谱的的投资者教育平台,股市直播,股票交流'
    }
  },
	data () {
		return {
      answerContent: '',  //老师的回答输入内容
      answerShow: false    //是否显示回答操作部分
		}
  },
  mounted () {
    this.$store.dispatch('getAd', ['payPaperTeacher'])
  },
	methods:{
    // 关注
    handleLike () {
      if (!this.$isLogin()) {
				Dialog.login()
				return
			}
      this.$store.dispatch('user/like', { teacher: this.teacherInfo, isLike: this.isLike }).then(resp => {
        this.$notify({
          title: '成功',
          message: this.isLike ? '已取消关注' : '关注成功',
          type: 'success'
        })
        this.isLike = !this.isLike
      })
    },
		// 老师回答问题
		handleAnswer (e) {
			if(!this.$isLogin()) {
				Dialog.login()
				return
			}
			let params = {
        id: this.data.id,
        content: this.answerContent
      }
      Dialog.confirm('回答问题', '是否将此回答发送给用户？').then(() => {
        e.target.disabled = false
        this.$axios._post('Ask/Answer', params).then(() => {
          e.target.disabled = true
          this.$notify({
            title: '成功',
            message: '回答成功',
            type: 'success'
          })
          this.$axios._get('Ask/Detail', { id: this.$route.params.id }).then(res => {
            this.data = res
          }).catch(() => {
            Dialog.alert('出现错误，请重新刷新页面！')
          })
        }).catch(() => {
          e.target.disabled = true
        })
      })
    },
    // 提问
    handleAsk (type) {
      if(!this.$isLogin()){
        Dialog.login()
        return
      }
      Dialog.ask(type)
    },
    // 解锁答案
    handleUnlock (item) {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      Dialog.unlockAsk(item, (res) => {
        Dialog.alert('解锁成功', {
          type: 'success'
        }).then(_ => {
          this.$axios._get('Ask/Detail', { id: this.$route.params.id }).then(res => {
            this.data = res
          }).catch(() => {
            Dialog.alert('出现错误，请重新刷新页面！')
          })
        })
      })
    }
	},
	computed: {
    authUser () {
      return this.$store.state.user.data
    },
    isTeacher () {
      return this.$store.getters['user/isTeacher']
    },
    isTheTeacher () {
      return this.$store.getters['teacher/isTeacher']
    }
	}
}
</script>
